// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"52165ff9","990":"e4428fb8"}[chunkId] + ".chunk.js";
};